webpackJsonp([1],{

/***/ "7+p6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__plugins_commandList__ = __webpack_require__("baUs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__plugins_taskList__ = __webpack_require__("Aunj");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'VueTerminalEmulator',
  data: function data() {
    return {
      title: 'Elder J\'s Resume',
      messageList: [],
      actionResult: '',
      lastLineContent: '...',
      inputCommand: '',
      supportingCommandList: ''
    };
  },

  props: {
    defaultTask: {
      required: false
    }
  },
  computed: {
    lastLineClass: function lastLineClass() {
      if (this.lastLineContent === '&nbsp') {
        return 'cursor';
      } else if (this.lastLineContent === '...') {
        return 'loading';
      }
    }
  },
  created: function created() {
    var _this = this;

    this.supportingCommandList = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_1__plugins_commandList__["a" /* default */]).concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_2__plugins_taskList__["a" /* default */]));
    this.handleRun(this.defaultTask).then(function () {
      _this.pushToList({ type: 'system', label: 'System', message: 'Type "help" to get a supporting command list.' });
      _this.handleFocus();
    });
  },

  methods: {
    handleFocus: function handleFocus() {
      this.$refs.inputBox.focus();
    },
    handleCommand: function handleCommand() {
      var _this2 = this;

      this.pushToList({ message: '$ ' + this.inputCommand });
      var commandArr = this.inputCommand.split(' ');
      if (commandArr[0] === 'help') {
        this.printHelp(commandArr[1]);
      } else if (__WEBPACK_IMPORTED_MODULE_1__plugins_commandList__["a" /* default */][this.inputCommand]) {
        __WEBPACK_IMPORTED_MODULE_1__plugins_commandList__["a" /* default */][this.inputCommand].messages.map(function (item) {
          return _this2.pushToList(item);
        });
      } else if (__WEBPACK_IMPORTED_MODULE_2__plugins_taskList__["a" /* default */][this.inputCommand.split(' ')[0]]) {
        this.handleRun(this.inputCommand.split(' ')[0], this.inputCommand);
      } else {
        this.pushToList({ type: 'System', message: 'Unknown Command.' });
        this.pushToList({ type: 'System', message: 'type "help" to get a supporting command list.' });
      }
      this.inputCommand = '';
      this.autoScroll();
    },
    handleRun: function handleRun(taskName, input) {
      var _this3 = this;

      this.lastLineContent = '...';
      return __WEBPACK_IMPORTED_MODULE_2__plugins_taskList__["a" /* default */][taskName][taskName](this.pushToList, input).then(function (done) {
        _this3.pushToList(done);
        _this3.lastLineContent = '&nbsp';
      }).catch(function (error) {
        _this3.pushToList(error || { type: 'error', label: 'Error', message: 'Something went wrong!' });
        _this3.lastLineContent = '&nbsp';
      });
    },
    pushToList: function pushToList(message) {
      this.messageList.push(message);
      this.autoScroll();
    },
    printHelp: function printHelp(input) {
      var _this4 = this;

      if (!input) {
        this.pushToList({ message: 'Here is a list of supporting command.' });
        this.supportingCommandList.map(function (command) {
          if (__WEBPACK_IMPORTED_MODULE_1__plugins_commandList__["a" /* default */][command]) {
            _this4.pushToList({ type: 'success', label: command, message: '---> ' + __WEBPACK_IMPORTED_MODULE_1__plugins_commandList__["a" /* default */][command].description });
          } else {
            _this4.pushToList({ type: 'success', label: command, message: '---> ' + __WEBPACK_IMPORTED_MODULE_2__plugins_taskList__["a" /* default */][command].description });
          }
          return undefined;
        });
        this.pushToList({ message: 'Enter help <command> to get help for a particular command.' });
      } else {
        var command = __WEBPACK_IMPORTED_MODULE_1__plugins_commandList__["a" /* default */][input] || __WEBPACK_IMPORTED_MODULE_2__plugins_taskList__["a" /* default */][input];
        this.pushToList({ message: command.description });
      }
      this.autoScroll();
    },
    time: function time() {
      return new Date().toLocaleTimeString().split('').splice(2).join('');
    },
    autoScroll: function autoScroll() {
      var _this5 = this;

      this.$nextTick(function () {
        _this5.$refs.terminalWindow.scrollTop = _this5.$refs.terminalLastLine.offsetTop;
      });
    }
  }
});

/***/ }),

/***/ "Aunj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);

function generateTime() {
  var timeNow = new Date();
  var hours = timeNow.getHours();
  var minutes = timeNow.getMinutes();
  var seconds = timeNow.getSeconds();
  var timeString = '' + hours;
  timeString += (minutes < 10 ? ':0' : ':') + minutes;
  timeString += (seconds < 10 ? ':0' : ':') + seconds;
  return timeString;
}

var selfIntroduction = [
// { type: 'prompt', message: 'cd xu\'sresume' },
{ message: 'Thanks for your visiting, here is my resume, let me introduce myself first.' }, { time: generateTime(), type: 'info', label: 'Name:', message: 'Elder J ' }, { time: generateTime(), type: 'info', label: 'Apply For:', message: 'Professor' }, { time: generateTime(), type: 'info', label: 'School:', message: 'National Central University & Shanghai Jiao Tong University' }, { time: generateTime(), type: 'info', label: 'Diploma:', message: 'Graduate' }, { time: generateTime(), type: 'info', label: 'Major:', message: 'Electrical Engineering' }, { time: generateTime(), type: 'info', label: 'Age:', message: '91' }, { time: generateTime(), type: 'info', label: 'Sex:', message: 'Male' }, { time: generateTime(),
  type: 'info', label: 'Experence:',
  message: {
    text: 'Here is my work experence:',
    list: ['1947-1951 work as Power Supply Engineer and Associate Engineer in Shanghai HaiNing Foreign firm;', '1956-1959 work as Deputy Director and Factory director in Changchun First Automobile Works.']
  }
}];

/* harmony default export */ __webpack_exports__["a"] = ({
  selfIntroduct: {
    description: 'Introducting myself.',
    selfIntroduct: function selfIntroduct(pushToList) {
      var i = 0;
      var p = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        var interval = setInterval(function () {
          pushToList(selfIntroduction[i]);
          i++;
          if (!selfIntroduction[i]) {
            clearInterval(interval);
            resolve({ type: 'success', label: 'Done', message: 'My self introduction is over!' });
          }
        }, 1000);
      });
      return p;
    }
  },
  open: {
    description: 'Open a specified url in a new tab.',
    open: function open(pushToList, input) {
      var p = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var url = input.split(' ')[1];
        if (!url) {
          reject({ type: 'error', label: 'Error', message: 'a url is required!' });
          return;
        }
        pushToList({ type: 'success', label: 'Success', message: 'Page Opening' });

        if (input.split(' ')[1].indexOf('http') === -1) {
          url = 'http://' + input.split(' ')[1];
        }
        window.open(url, '_blank');
        resolve({ type: 'success', label: 'Success', message: 'Page Opened!' });
      });
      return p;
    }
  }

});

/***/ }),

/***/ "F+vh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c2ae79e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("ujlr");
function injectStyle (ssrContext) {
  __webpack_require__("F+vh")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c2ae79e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Msdv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VueTerminalEmulator_vue__ = __webpack_require__("7+p6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6abbebb1_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VueTerminalEmulator_vue__ = __webpack_require__("XorN");
function injectStyle (ssrContext) {
  __webpack_require__("iCZ/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6abbebb1"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VueTerminalEmulator_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6abbebb1_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VueTerminalEmulator_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__("M93x");
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.


// import router from './router';

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  // router,
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),

/***/ "XorN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"terminal",staticStyle:{"width":"60%","margin":"0 auto"}},[_c('div',{staticStyle:{"position":"relative"}},[_c('div',{staticClass:"header"},[_c('h4',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('div',{ref:"terminalWindow",staticStyle:{"position":"absolute","top":"0","left":"0","right":"0","overflow":"auto","z-index":"1","margin-top":"30px","max-height":"650px"}},[_c('div',{staticClass:"terminal-window",attrs:{"id":"terminalWindow"}},[_c('p',[_vm._v("Welcome to "+_vm._s(_vm.title)+".")]),_vm._v(" "),_c('p',[_c('span',{staticClass:"prompt"}),_c('span',{staticClass:"cmd"},[_vm._v("cd "+_vm._s(_vm.title))])]),_vm._v(" "),_vm._l((_vm.messageList),function(item,index){return _c('p',{key:index},[_c('span',[_vm._v(_vm._s(item.time))]),_vm._v(" "),(item.label)?_c('span',{class:item.type},[_vm._v(_vm._s(item.label))]):_vm._e(),_vm._v(" "),(!item.message.list)?_c('span',{staticClass:"cmd"},[_vm._v(_vm._s(item.message))]):_c('span',{staticClass:"cmd"},[_c('span',[_vm._v(_vm._s(item.message.text))]),_vm._v(" "),_c('ul',_vm._l((item.message.list),function(li,index){return _c('li',{key:index},[(li.label)?_c('span',{class:li.type},[_vm._v(_vm._s(li.label)+":")]):_vm._e(),_vm._v(" "),_c('pre',[_vm._v(_vm._s(li))])])}))])])}),_vm._v(" "),(_vm.actionResult)?_c('p',[_c('span',{staticClass:"cmd"},[_vm._v(_vm._s(_vm.actionResult))])]):_vm._e(),_vm._v(" "),_c('p',{ref:"terminalLastLine",staticClass:"terminal-last-line",on:{"click":_vm.handleFocus}},[(_vm.lastLineContent==='&nbsp')?_c('span',{staticClass:"prompt"},[_vm._v(" \\"+_vm._s(_vm.title)+" ")]):_vm._e(),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.inputCommand))]),_vm._v(" "),_c('span',{class:_vm.lastLineClass,domProps:{"innerHTML":_vm._s(_vm.lastLineContent)}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.inputCommand),expression:"inputCommand"}],ref:"inputBox",staticClass:"input-box",attrs:{"disabled":_vm.lastLineContent!=='&nbsp',"autofocus":"true","type":"text"},domProps:{"value":(_vm.inputCommand)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.handleCommand($event)},"input":function($event){if($event.target.composing){ return; }_vm.inputCommand=$event.target.value}}})])],2)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"shell-dots"},[_c('li',{staticClass:"red"}),_vm._v(" "),_c('li',{staticClass:"yellow"}),_vm._v(" "),_c('li',{staticClass:"green"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "baUs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var commandList = {
  experence: {
    description: 'Description of my work experence.',
    messages: [{ type: 'info', label: 'Shanghai HaiNing Foreign firm', message: '1947-1951 work as Power Supply Engineer and Associate Engineer' }, { type: 'error', label: 'Changchun First Automobile Works', message: '1956-1959 work as Deputy Director and Factory director ' }, { type: 'error', label: 'Changchun First Automobile Works', message: '1956-1959 work as Deputy Director and Factory director ' }]
  },
  education: {
    description: 'My education background.',
    messages: [{ type: 'warning', label: 'Graduate', message: '1943-1945, Major in Electrical Engineering, National Central University ' }, { type: 'success', label: 'Graduate', message: '1946-1947, Major in Electrical Engineering, Shanghai Jiao Tong University ' }]
  },
  skills: {
    description: 'Return a list of my skills and my rating of them.',
    messages: [{ message: '- Ukulele(Hawaiian Guitar)     100/100' }, { message: '- Pianio                       90/100' }, { message: '- Erhu                         80/100' }, { message: '- Flute                        70/100' }, { message: '- Pipe Organ                   60/100' }]
  },
  project: {
    description: 'Return a list of project participate/create.',
    messages: [{ message: {
        text: 'A terminal emulator in Vue.',
        list: ['Tech: VueJS + CSS3', 'Github: https://github.com/dongsuo/vue-terminal-emulator', 'Online: https://dongsuo.github.io/vue-terminal-emulator/']
      }
    }]
  },
  languages: {
    description: 'Return a list of languages that I\'m good at.',
    messages: [{ message: 'English' }, { message: 'Russian' }, { message: 'Japanese' }, { message: 'French' }, { message: 'German' }, { message: 'Spanish' }]
  },
  contact: {
    description: 'How to contact me',
    messages: [{ type: 'error', label: 'Email', message: 'xuxiaofei915@gmail.com' }, { type: 'info', label: 'Github', message: 'https://github.com/dongsuo' }, { type: 'success', label: 'WeChat Offical Account', message: 'dongsuo' }] },
  about: {
    description: 'About author',
    messages: [{ message: 'My name is xu xiaofei. I\'m a programmer, You can visit my personal website at http://xiaofeixu.cn to learn more about me.' }]
  }
};
/* harmony default export */ __webpack_exports__["a"] = (commandList);

/***/ }),

/***/ "iCZ/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ujlr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('vue-terminal-emulator',{attrs:{"defaultTask":"selfIntroduct"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_VueTerminalEmulator__ = __webpack_require__("Msdv");
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  components: { VueTerminalEmulator: __WEBPACK_IMPORTED_MODULE_0__components_VueTerminalEmulator__["a" /* default */] }
});

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.1670ad7d01e8e5b3e9d4.js